

export default class Redirect {

    //public static ASuite: string = ""
    public static ASuite: string = process.env.REACT_APP_ASUITE_URL;

    /**
     * Direct redirect to the specified URL. 
     */
    public static to(url: string) {
        window.location.assign(url);
    }

    /**
     * Redirect to ASuite. 
     * @param shouldReturn if true, then the ASuite URL is constructed with query params
     * indicating a request to redirect back to GeoDoc, whilst preserving the 
     * query params sent to GeoDoc.
     * 
     * This type of redirect request happens when the user is not authenticated
     * and needs to log in at ASuite before using GeoDoc. 
     */
    public static asuite(shouldReturn: boolean = false) {
        // Retriev ASuite URL
        let link = process.env.REACT_APP_ASUITE_URL
        if (shouldReturn) {
            // Construct redirect request picked up by ASuite
            const params = window.location.search
            console.log(window.location.search)
            link += `/?s=geodoc${params.replace("?", "&")}`
        }
        window.location.assign(link)
    }
}